"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDiscounts = void 0;
var CommonDiscounts;
(function (CommonDiscounts) {
    CommonDiscounts["AUTOPAY"] = "AutoPay";
    CommonDiscounts["CUSTOMER_LOYALTY"] = "Customer Loyalty";
    CommonDiscounts["FUTURE_EFFECTIVE_DATE"] = "Future Effective Date";
    CommonDiscounts["MEMBERSHIP_LENGTH"] = "Membership Length";
    CommonDiscounts["MILITARY_SERVICE"] = "Military Service";
    CommonDiscounts["MULTI_PRODUCT"] = "Multi-Product";
    CommonDiscounts["ONLINE_QUOTE"] = "Online Quote";
    CommonDiscounts["PREPAYMENT"] = "Paid in Full";
    CommonDiscounts["PAPERLESS"] = "Paperless";
    CommonDiscounts["PAYMENT_HISTORY"] = "Payment History";
    CommonDiscounts["OTHER"] = "Other";
})(CommonDiscounts = exports.CommonDiscounts || (exports.CommonDiscounts = {}));
